import { render, staticRenderFns } from "./ClassAgentIconHover.vue?vue&type=template&id=c74626c2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c74626c2')) {
      api.createRecord('c74626c2', component.options)
    } else {
      api.reload('c74626c2', component.options)
    }
    module.hot.accept("./ClassAgentIconHover.vue?vue&type=template&id=c74626c2&", function () {
      api.rerender('c74626c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/ClassAgentIconHover.vue"
export default component.exports